import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

interface TrendingMenu {
  id: string;
  name: string;
  imageUrl: string;
  category?: string;
  rating?: number;
}

interface TrendingItems {
  daily: TrendingMenu | null;
  weekly: TrendingMenu | null;
  monthly: TrendingMenu | null;
}

interface TrendingMenusCardProps {
  trendingItems: TrendingItems;
}

type TimeRange = "today" | "this_week" | "this_month";

export default function TrendingMenusCard({ trendingItems }: TrendingMenusCardProps) {
  const [timeRange, setTimeRange] = useState<TimeRange>("this_month");

  const timeRangeLabels: Record<TimeRange, string> = {
    today: "Today",
    this_week: "This Week",
    this_month: "This Month",
  };

  const getCurrentMenu = (): TrendingMenu | null => {
    switch (timeRange) {
      case "today":
        return trendingItems.daily;
      case "this_week":
        return trendingItems.weekly;
      case "this_month":
        return trendingItems.monthly;
      default:
        return trendingItems.monthly;
    }
  };

  const menu = getCurrentMenu();

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-3 sm:p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="m-0 text-base font-semibold text-gray-900 sm:text-lg">Trending Menu Item</h3>
        <div className="relative">
          <select
            value={timeRange}
            onChange={(event) => setTimeRange(event.target.value as TimeRange)}
            className="appearance-none rounded-xl border border-gray-200 bg-white py-2 pl-3 pr-9 text-xs text-gray-800 outline-none transition focus:border-gray-400 sm:text-sm"
          >
            <option value="today">{timeRangeLabels.today}</option>
            <option value="this_week">{timeRangeLabels.this_week}</option>
            <option value="this_month">{timeRangeLabels.this_month}</option>
          </select>
          <ChevronDown
            size={16}
            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
          />
        </div>
      </div>

      {menu ? (
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:gap-4">
          <img
            src={menu.imageUrl}
            alt={menu.name}
            className="h-32 w-full rounded-2xl object-cover sm:h-24 sm:w-24 sm:shrink-0"
          />
          <div className="min-w-0 flex flex-col justify-center">
            <p className="m-0 break-words text-sm font-semibold text-gray-900 sm:text-base">{menu.name}</p>
            {menu.category ? <p className="m-0 text-xs text-gray-900 sm:text-sm">{menu.category}</p> : null}
          </div>
        </div>
      ) : (
        <div className="flex h-24 items-center justify-center rounded-2xl bg-gray-50 text-sm text-gray-400">
          No trending item for {timeRangeLabels[timeRange].toLowerCase()}
        </div>
      )}
    </div>
  );
}
